import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from './api';

export type SignupMode = 'open' | 'request' | 'closed';

export interface PublicSettings {
  signup_mode: SignupMode;
  signup_disabled_message: string | null;
}

export interface AdminSettings extends PublicSettings {}

export const PUBLIC_SETTINGS_KEY = ['settings', 'public'] as const;
export const ADMIN_SETTINGS_KEY = ['settings', 'admin'] as const;

export function usePublicSettings() {
  return useQuery<PublicSettings>({
    queryKey: PUBLIC_SETTINGS_KEY,
    queryFn: () => api.get<PublicSettings>('/api/settings/public'),
    staleTime: 60_000,
  });
}

export function useAdminSettings() {
  return useQuery<AdminSettings>({
    queryKey: ADMIN_SETTINGS_KEY,
    queryFn: () => api.get<AdminSettings>('/api/admin/settings'),
  });
}

export function useUpdateAdminSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: Partial<AdminSettings>) =>
      api.patchJson<AdminSettings>('/api/admin/settings', input),
    onSuccess: (data) => {
      qc.setQueryData(ADMIN_SETTINGS_KEY, data);
      qc.setQueryData(PUBLIC_SETTINGS_KEY, data);
    },
  });
}
